import { atom } from "recoil"
import { Key } from "../EnumKey"

const queryStringAtom = atom({
  key: Key.SEARCHSTRING,
  default: "N4XyA" as string
})

export default queryStringAtom